import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'notification', {
    email: 'Email',
    sms: 'SMS',
    inbox: 'Inbox',
    iospush: 'iOS Push',
    allowAll: 'Allow all notifications, except the ones that I have turned off',
    allowImportant: 'Allow only important system messages related to account and security',
    channels: 'Notification Channels',
    categories: 'Notification Categories',
  });
}
